import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PrivacyOptIn = ({
    value,
    onChange,
    onTermsClick,
    onPrivacyClick,
    customer_signup_consent_required,
}) => {
    const { t } = useTranslation('customer');

    if (!customer_signup_consent_required) {
        return null;
    }

    return (
        <div className="m2g-customer-privacy">
            <label
                htmlFor="m2g-customer-privacy-checkbox"
                data-loyalty-label
                className="m2g-customer-privacy-label"
            >
                <input
                    id="m2g-customer-privacy-checkbox"
                    data-privacy-checkbox
                    type="checkbox"
                    className="m2g-input"
                    checked={value}
                    onChange={e => {
                        onChange(e.target.checked);
                    }}
                />
                {t('privacy_policy_agree')}
            </label>
            <span
                className="m2g-text--link m2g-customer-privacy-link"
                onClick={e => {
                    onTermsClick(e);
                }}
            >
                {t('privacy_terms_link')}
            </span>
            <label data-privacy-label className="m2g-customer-loyalty-label">
                {t('privacy_policy_account_creation')}
            </label>
            <span
                className="m2g-text--link"
                onClick={e => {
                    onPrivacyClick(e);
                }}
            >
                {t('privacy_link')}
            </span>
        </div>
    );
};

PrivacyOptIn.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    customer_signup_consent_required: PropTypes.bool.isRequired,
};

export default PrivacyOptIn;
